// extracted by mini-css-extract-plugin
module.exports = {"section":"h_t"};